var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "event-card-container",
      class: _vm.isNoTrans ? "noTransition" : null
    },
    [
      _c(
        "div",
        { staticClass: "part-one" },
        [
          _c("div", { staticClass: "part-one-detail" }, [
            _c("div", { staticClass: "approve-icon part-one-icon" }),
            _vm._v(" "),
            _c("div", { staticClass: "part-one-event-name" }, [
              _c("div", { staticClass: "part-one-pref-date" }, [
                _vm._v(_vm._s(_vm.event.prefDate))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "part-one-event-name-text" }, [
                _vm._v(_vm._s(_vm.event.eventName))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper-menu" }, [
              _vm.isLive
                ? _c("div", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover.bottom",
                        modifiers: { hover: true, bottom: true }
                      }
                    ],
                    staticClass: "wrapper-status-icon",
                    attrs: { title: "This event is live" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover.bottom",
                    modifiers: { hover: true, bottom: true }
                  }
                ],
                staticClass: "wrapper-more-icon",
                attrs: { title: "More" },
                on: {
                  click: function($event) {
                    _vm.openMenu()
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("click-outside", { attrs: { handler: _vm.closeMenu } }, [
            _vm.isOpenMenu
              ? _c(
                  "div",
                  { staticClass: "wrapper-list" },
                  [
                    _c(
                      "b-list-group",
                      [
                        _c(
                          "b-list-group-item",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center",
                            on: {
                              click: function($event) {
                                _vm.openModal()
                              }
                            }
                          },
                          [
                            _c("div", {
                              staticClass: "icon-information-black"
                            }),
                            _vm._v(" "),
                            _c("div", [_vm._v("Event details")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-list-group-item",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center",
                            on: {
                              click: function($event) {
                                _vm.updateIsLiveEvent("LIVE")
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "status-icon-black" }),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "Make event " +
                                  _vm._s(_vm.isLive ? "un-live" : "live")
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "part-two" }, [
        _vm.event.trackingStatus !== "Shipping info not entered"
          ? _c("div", { class: { partTwoDetail: _vm.isAdminOrEMView } }, [
              _c("div", { staticClass: "oval oval-green" }),
              _vm._v(" "),
              _c("div", { staticClass: "supplies-status" }, [
                _vm._v(_vm._s(_vm.event.trackingStatus))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.event.trackingStatus === "Shipping info not entered"
          ? _c("div", { class: { partTwoDetail: _vm.isAdminOrEMView } }, [
              _c("div", { staticClass: "oval oval-red" }),
              _vm._v(" "),
              _c("div", { staticClass: "supplies-status" }, [
                _vm._v(_vm._s(_vm.event.trackingStatus))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAdminOrEMView
          ? _c("div", { staticClass: "part-two-detail" }, [
              _c("div", { staticClass: "oval oval-green" }),
              _vm._v(" "),
              _c("div", { staticClass: "supplies-status" }, [
                _vm._v(
                  "Staffed for " +
                    _vm._s(
                      _vm.event.numStaffScreener +
                        _vm.event.numStaffLead +
                        _vm.event.numStaffConcierge
                    ) +
                    "/" +
                    _vm._s(
                      _vm.event.maxStaffScreener +
                        _vm.event.maxStaffLead +
                        _vm.event.maxStaffConcierge
                    )
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAdminOrEMView
          ? _c("div", [
              _vm.event.emailReminderStatus ===
              _vm.emailTemplateConsts.notReminded
                ? _c("div", { staticClass: "oval oval-red" })
                : _vm._e(),
              _vm._v(" "),
              _vm.event.emailReminderStatus !==
                _vm.emailTemplateConsts.notReminded &&
              _vm.event.emailReminderStatus !== _vm.emailTemplateConsts.thankyou
                ? _c("div", { staticClass: "oval oval-orange" })
                : _vm._e(),
              _vm._v(" "),
              _vm.event.emailReminderStatus === _vm.emailTemplateConsts.thankyou
                ? _c("div", { staticClass: "oval oval-green" })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "supplies-status" }, [
                _vm._v(
                  "Last Email Sent: " +
                    _vm._s(
                      _vm._f("templateName")(_vm.event.emailReminderStatus)
                    )
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAdminOrEMView
          ? _c("div", [
              _vm.event.maxParticipant === 0 ||
              _vm.event.numParticipant < _vm.event.maxParticipant / 2
                ? _c("div", { staticClass: "oval oval-red" })
                : _vm._e(),
              _vm._v(" "),
              _vm.event.maxParticipant > 0 &&
              _vm.event.numParticipant >= _vm.event.maxParticipant / 2 &&
              _vm.event.numParticipant < _vm.event.maxParticipant
                ? _c("div", { staticClass: "oval oval-orange" })
                : _vm._e(),
              _vm._v(" "),
              _vm.event.maxParticipant > 0 &&
              _vm.event.numParticipant >= _vm.event.maxParticipant
                ? _c("div", { staticClass: "oval oval-green" })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "supplies-status" }, [
                _vm._v(
                  "Participants Signups: " +
                    _vm._s(_vm.event.numParticipant) +
                    "/" +
                    _vm._s(_vm.event.maxParticipant)
                )
              ])
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-47ae53c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47ae53c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eventManagement/manage/EventCard.vue
// module id = 1755
// module chunks = 1